// extracted by mini-css-extract-plugin
export default {"lockerLegend":"CompletedByLockers-lockerLegend-a184","legendLabel":"CompletedByLockers-legendLabel-afa3","legendTitle":"CompletedByLockers-legendTitle-f39d"};